import { Link } from 'react-router-dom';
import styled from "styled-components";
import Dialog from "~src/shared/dialogs/dialog/Dialog";

export const SurveyInviteWrapper = styled.section`
  padding: 2rem;
  border-top: 7px solid ${({ theme }) => theme.black.a1};
`;

export const Details = styled.section`
  display: flex;
  padding: 0.5rem 0rem;
  font-size: 1rem;
  align-items: center;
`;

export const LinkStyled = styled(Link)`
  overflow: wrap;
  text-overflow: ellipsis;
  display: -webkit-box;
  white-space: pre-wrap;
  word-wrap: break-word; /* IE */
  word-break: break-all; /* Non-standard */
  white-space: -moz-pre-wrap; /* Mozilla */
  white-space: -pre-wrap; /* Opera 4-6 */
  white-space: -o-pre-wrap; /* Opera 7 */
  white-space: pre-line;
  max-width: 100%;
  overflow-wrap: anywhere;
`

export const QRCodeLabelContainer = styled.div`
  display: flex;
  align-items: center;
  color: ${({ theme }) => theme.baseBlue.a10};
  width: 100%;
  cursor: pointer;
  text-transform: uppercase;

  &:hover {
    color: ${({ theme }) => theme.baseBlue.a8}; 
  }
`
export const Header = styled.div`
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.73;
  text-align: left;
  color: ${({ theme }) => theme.baseBlue.a8};
  display: flex;
  width: 100%;
`;

export const QRCodeLabel = styled.div`
  font-size: 0.9rem;
  font-weight: 500;
  padding-top: 0.2rem;
`

export const QRCodeIcon = styled.div`
  width: initial;
  margin-right: 0.4rem;
  &:hover {
    opacity: 1 !important;
  }
`;

export const DialogStyled = styled(Dialog)`
  div.ant-modal-content {
    overflow: hidden;

    .ant-modal-close-x {
      color: unset;
      font-size: 16px;
    }

    .ant-modal-body {
      padding: 0;
    }
  }
`;

export const DialogHeader = styled.div`
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.73;
  text-align: left;
  color: ${({ theme }) => theme.baseBlue.a8};
  width: 100%;
  padding: 1rem;
`